import { useState, useEffect } from "react";
import type { IAnswer, IQuestion } from "@/types/types";
import { Icon } from "@/components/icons/Icon";
import BloquedAnswer from "./answer/BloquedAnswer";
import Answer from "./answer/Answer";
import { createAnswersList } from "../inspection.util";
import { usePhase } from "@/store/usePhase";

interface DisabledAnswersColumnProps {
  columnPhase: number;
  columnName: string;
  questions: number;
  questionsList: IQuestion[];
  answers?: IAnswer[];
}

const DisabledAnswersColumn = ({
  columnPhase,
  columnName,
  questions,
  answers = [],
  questionsList,
}: DisabledAnswersColumnProps) => {
  const { currentPhase } = usePhase();
  const [answersList, setAnswersList] = useState<any[]>([]);

  useEffect(() => {
    if (
      columnPhase &&
      currentPhase &&
      questionsList.length &&
      answers?.length &&
      (columnPhase < currentPhase || columnPhase === 4)
    ) {
      const newAnswersList = createAnswersList(questionsList, answers);
      setAnswersList(newAnswersList);
    } else {
      const newAnswersList = createAnswersList(questionsList, answers);
      setAnswersList(newAnswersList);
    }
  }, [columnPhase, currentPhase, questionsList, answers, columnPhase]);

  return (
    <div className="bg-ib-gray-lightest w-[175px] min-w-[175px] px-3 rounded-sm py-4 flex flex-col gap-y-4">
      <div className="text-ib-main font-ib-bold flex flex-row gap-x-1 items-center">
        <Icon name="lockClose" className="size-4 text-ib-gray-disabled" />
        <span className="text-ib-gray-dark-2 over overflow-x-hidden whitespace-nowrap text-ellipsis">
          {columnName}
        </span>
      </div>
      {currentPhase && columnPhase > currentPhase ? (
        <>
          {Array.from({ length: questions }).map((_, index) => (
            <BloquedAnswer key={`empty-${columnPhase}-${index}`} />
          ))}
        </>
      ) : (
        answersList.map((answer, index) => (
          <Answer
            key={`disabled-${columnPhase}-${index}`}
            empty={answer.empty}
            item={answer}
            idx={index + 1}
          />
        ))
      )}
    </div>
  );
};

export default DisabledAnswersColumn;
